import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from './Layout';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const accessToken = props.oidc?.user?.access_token;

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);

        const currentValue = props.formFields?.[name];
        if (currentValue !== undefined) {
            ref.instance().option('value', currentValue);
        }
    }, [props.formRefs, props.formFields]);

    const loadRChargeDataSource = useCallback(() => {
        const store = createStore({
            key: 'RowId',
            loadParams: {
                'chargeCodeFilter.Status': function() {
                    return 'A';
                },
                'chargeCodeFilter.ChargeType': function() {
                    return 'T';
                },
                'chargeCodeFilter.ChargeCode': function() {
                    return '';
                },
                'chargeCodeFilter.Description': function() {
                    return '';
                },
                'chargeCodeFilter.RevenueGroup': function() {
                    return '';
                },
                'chargeCodeFilter.Frequency': function() {
                    return '';
                },
                'chargeCodeFilter.RowId': function() {
                    return null;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.ChargeCode.GetChargeCodes}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });

        const dataSource = new DataSource({
            store: store,
            sort: [{ selector: "ChargeCode", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return dataSource;
    }, [accessToken]);

    const handlePrimaryFormLoad = useCallback(() => {
        const chargeTypeOptions = [
            { id: 'Transaction Charge', text: 'Transaction Charge' },
            { id: 'Item Charge', text: 'Item Charge' }
        ];
        const statusOptions = [
            { id: 'A', text: 'Active' },
            { id: 'I', text: 'Inactive' }
        ];
        const chargeDescSourceOptions = [
            { id: 'C', text: 'From Charge Code' },
            { id: 'M', text: 'Manually Enter' }
        ];

        // Use setTimeout to ensure formRefs are available after FormField renders
        setTimeout(() => {
            loadLookupClient("CHARGETYPE", chargeTypeOptions);
            loadLookupClient("RCHARGE", loadRChargeDataSource(), 'RowId', 'ChargeCode');
            loadLookupClient("STATUS", statusOptions);
            loadLookupClient("CHARGEDESCRIPTIONSOURCE", chargeDescSourceOptions);
        }, 100);
    }, [loadLookupClient, loadRChargeDataSource]);

    // Load ChargeType, RCharge, Status, and ChargeDescSource dropdowns when formRefs become available
    useEffect(() => {
        const chargeTypeOptions = [
            { id: 'Transaction Charge', text: 'Transaction Charge' },
            { id: 'Item Charge', text: 'Item Charge' }
        ];
        const statusOptions = [
            { id: 'A', text: 'Active' },
            { id: 'I', text: 'Inactive' }
        ];
        const chargeDescSourceOptions = [
            { id: 'C', text: 'From Charge Code' },
            { id: 'M', text: 'Manually Enter' }
        ];

        loadLookupClient("CHARGETYPE", chargeTypeOptions);
        loadLookupClient("RCHARGE", loadRChargeDataSource(), 'RowId', 'ChargeCode');
        loadLookupClient("STATUS", statusOptions);
        loadLookupClient("CHARGEDESCRIPTIONSOURCE", chargeDescSourceOptions);
    }, [loadLookupClient, loadRChargeDataSource, props.formFields?.CHARGETYPE, props.formFields?.RCHARGE, props.formFields?.STATUS, props.formFields?.CHARGEDESCRIPTIONSOURCE]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='C3D5E7F9-A1B2-4C5D-6E7F-8A9B0C1D2E3F'
                layoutName='WMDynValChargeConfigPrimaryForm'
                defaultFormSchema={PrimaryLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);


